// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtCardDrugModel {
    static getAttributeTypeMap() {
        return ExtCardDrugModel.attributeTypeMap;
    }
}
ExtCardDrugModel.discriminator = undefined;
ExtCardDrugModel.additionalProperties = false;
ExtCardDrugModel.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
];
//# sourceMappingURL=extCardDrugModel.js.map